module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAAAXNSR0IArs4c6QAAAO1JREFUOE/tlL8PwUAUx9/rnd1oVe2VCa2EhM1s468k8RfYGCTqx4QrutoYJdqedDhpqtIahVvv8z5535eXh5DhcWa6jC+LaSimAeG/Y1hC39upbCrwl72M+4tmtlPrDYUohDn2XOaIrwbXrSbF4Kby1SaaFTmztozblWehZraA4Bg9v68d17P4ahxKtbagZOTfg175tFrIOm6YLiYt5F6tdpQcHUqhZKQouHsD47SZRrsKmURZCEWFgpIpen4n7ChJJLt/K4sKAaAAAOd3okwyKURKJsLzu/FomWNmOQA/K2PmBRDzn87ohRfi+gAHQ7Po+qkrIQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/image/download-icon.png
// module id = 5UEX
// module chunks = 2